import { EqlField } from 'generated/graphql';
import { AggregatePeriod, GroupBy, TimeRange } from 'v2/core/entities';
import { SortBy } from 'v2/core/entities/feedback/sortBy';
import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { FieldName, SourceName } from 'v2/core/entities/fields';
import { Timezone } from 'v2/core/entities/user';
import { UUID } from 'v2/core/entities/uuid';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

export type GroupByField = FieldName | string;

export enum ExpressionType {
  Aggregates = 'aggregates',
  Records = 'records',
}

export interface Join {
  eql: Omit<EQLProps, 'sourceDetailsMap'>;
  alias: string;
}

export interface EQLProps {
  expressionType: ExpressionType;
  sourceDetailsMap: Map<SourceName, SourceDetail>;
  whereClause?: WhereClause;
  dateRange?: TimeRange;
  groupBy?: GroupBy;
  sortBy?: SortBy;
  aggregatePeriod?: AggregatePeriod;
  timezone?: Timezone;
  taxonomyID?: UUID;
  eqlFields?: EqlField[];
  delta?:
    | {
        type: 'deltaOffset';
        value: {
          aggregatePeriod: AggregatePeriod;
          multipler: number;
        };
      }
    | {
        type: 'whereClause';
        value: WhereClause;
      }
    | {
        type: 'timerange';
        value: TimeRange;
      };
  functions?: EQLFunction[];
  joins?: Join[];
  deltaJoins?: Join[];
}

export interface EQLFunction {
  name: EQLFunctionName;
  params?: (string | number | boolean)[];
}

export enum EQLFunctionName {
  Count = 'funcCount',
  CountFor = 'funcCountFor',
  SentimentScore = 'funcSentimentScore',
  EntitySentimentScore = 'funcEntitySentimentScore',
  NormaliseByPercent = 'funcNormaliseByPercent',
  CountForLabels = 'funcCountForLabels',
  CountForPredictedOn = 'funcCountForPredictedOn',
  CountForMetadataValues = 'funcCountForMetadataValues',
  CountForLanguages = 'funcCountForLanguages',
  Top = 'funcTop',
  Anomaly = 'funcAnomaly',
  ApplyTaxonomy = 'funcApplyTaxonomy',
  DeltaTop = 'funcDeltaTop',
  Paginate = 'funcPaginate',
  DeltaPaginate = 'funcDeltaPaginate',
  Order = 'funcOrder',
  DeltaOrder = 'funcDeltaOrder',
  SearchBucketKeys = 'funcSearchBucketKeys',
  NPS = 'funcNps',
  CSAT = 'funcCsat',
  Mean = 'funcMean',
  Sum = 'funcSum',
}
